import { DataGridButtonCellProps } from '../types'
import { Button, Icon } from '@/components'

function DataGridButtonCell ( props: DataGridButtonCellProps ) {
    const {
        data, width, buttonProps,
    } = props
    const {
        variant, text, icon, color,
        onClick
    } = buttonProps

    return (
        <div className="data-grid-cell" style={ { width, margin: '0 2px' } }>
            <Button
                sx={ { width: '100%', height: '100%' } }
                className={ `data-grid-cell-${ icon ? 'icon' : 'button' }` }
                variant={ variant }
                color={ color }
                onClick={ () => onClick && onClick( data ) }
            >
                { icon ? <><Icon>{ icon }</Icon>{ text }</> : text }
            </Button>
        </div>
    )
}

export default DataGridButtonCell
